
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexS2SLNYqt2GMeta } from "/codebuild/output/src3433143458/src/pages/index.vue?macro=true";
import { default as aboutiA6E20Okg3Meta } from "/codebuild/output/src3433143458/src/pages/about.vue?macro=true";
import { default as dataQBjSLr3CKnMeta } from "/codebuild/output/src3433143458/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionFqW95picDWMeta } from "/codebuild/output/src3433143458/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioningxFxMlxpZOlMeta } from "/codebuild/output/src3433143458/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyHD7dQzlbKiMeta } from "/codebuild/output/src3433143458/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45accountpOEfLrENbYMeta } from "/codebuild/output/src3433143458/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statuey612heP9btMeta } from "/codebuild/output/src3433143458/src/pages/account-settings/statue.vue?macro=true";
import { default as supportD8LkVSKO7HMeta } from "/codebuild/output/src3433143458/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settingsWo8FHPBv6AMeta } from "/codebuild/output/src3433143458/src/pages/account-settings.vue?macro=true";
import { default as activate_45account4YDPJztj2GMeta } from "/codebuild/output/src3433143458/src/pages/activate-account.vue?macro=true";
import { default as companytSOf0APU6ZMeta } from "/codebuild/output/src3433143458/src/pages/admin/company.vue?macro=true";
import { default as consentswV4WJiVVLIMeta } from "/codebuild/output/src3433143458/src/pages/admin/consents.vue?macro=true";
import { default as leadsLp8UM5fslJMeta } from "/codebuild/output/src3433143458/src/pages/admin/leads.vue?macro=true";
import { default as paymentsBl7jMkNWTmMeta } from "/codebuild/output/src3433143458/src/pages/admin/payments.vue?macro=true";
import { default as premium9Ll4tdS4XQMeta } from "/codebuild/output/src3433143458/src/pages/admin/premium.vue?macro=true";
import { default as profilesib5Lcy2LkJMeta } from "/codebuild/output/src3433143458/src/pages/admin/profiles.vue?macro=true";
import { default as userszIK4Q8MQVYMeta } from "/codebuild/output/src3433143458/src/pages/admin/users.vue?macro=true";
import { default as change_45passwordI3u9YL83qDMeta } from "/codebuild/output/src3433143458/src/pages/change-password.vue?macro=true";
import { default as _91id_93zBcHPdChM2Meta } from "/codebuild/output/src3433143458/src/pages/chat/[id].vue?macro=true";
import { default as ai_46clientw5Va0fnZRwMeta } from "/codebuild/output/src3433143458/src/pages/chat/ai.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src3433143458/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexVWuUEJ3LS6Meta } from "/codebuild/output/src3433143458/src/pages/chat/index.vue?macro=true";
import { default as _91id_93kl30X2saNhMeta } from "/codebuild/output/src3433143458/src/pages/client/profile/[id].vue?macro=true";
import { default as indexmo1FxJ8Ui0Meta } from "/codebuild/output/src3433143458/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_93NjbINmMrnjMeta } from "/codebuild/output/src3433143458/src/pages/contacts/[id].vue?macro=true";
import { default as indexDUnC3wYE4OMeta } from "/codebuild/output/src3433143458/src/pages/contacts/index.vue?macro=true";
import { default as contacts8zZLO3tXpqMeta } from "/codebuild/output/src3433143458/src/pages/contacts.vue?macro=true";
import { default as _91userId_93ZR8Ku1LGf2Meta } from "/codebuild/output/src3433143458/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as indexxTA0Va8RDOMeta } from "/codebuild/output/src3433143458/src/pages/login/index.vue?macro=true";
import { default as register_45successbQIy4qIe24Meta } from "/codebuild/output/src3433143458/src/pages/login/register-success.vue?macro=true";
import { default as loginhcAiieRFrpMeta } from "/codebuild/output/src3433143458/src/pages/login.vue?macro=true";
import { default as logoutycdCRF6ruzMeta } from "/codebuild/output/src3433143458/src/pages/logout.vue?macro=true";
import { default as consentsEZgYpWODdpMeta } from "/codebuild/output/src3433143458/src/pages/manager/consents.vue?macro=true";
import { default as integrationsfs8jzaaYW9Meta } from "/codebuild/output/src3433143458/src/pages/manager/integrations.vue?macro=true";
import { default as leadsFWTmqccuUUMeta } from "/codebuild/output/src3433143458/src/pages/manager/leads.vue?macro=true";
import { default as paymentsGToW08zpnfMeta } from "/codebuild/output/src3433143458/src/pages/manager/payments.vue?macro=true";
import { default as profile8AyrxadDxxMeta } from "/codebuild/output/src3433143458/src/pages/manager/profile.vue?macro=true";
import { default as teammAM8fwGJbRMeta } from "/codebuild/output/src3433143458/src/pages/manager/team.vue?macro=true";
import { default as indexJbV7PsCjuYMeta } from "/codebuild/output/src3433143458/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clientOCKrpt3vKwMeta } from "/codebuild/output/src3433143458/src/pages/marketplace/search/[catId].client.vue?macro=true";
import { default as marketplaceA7e77wqEzNMeta } from "/codebuild/output/src3433143458/src/pages/marketplace.vue?macro=true";
import { default as subscribeMTP66ZJahHMeta } from "/codebuild/output/src3433143458/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46clientXgcT75xiNcMeta } from "/codebuild/output/src3433143458/src/pages/orders/find.client.vue?macro=true";
import { default as my_46clientrUCEEhSCksMeta } from "/codebuild/output/src3433143458/src/pages/orders/my.client.vue?macro=true";
import { default as privacymZVAMGpxyjMeta } from "/codebuild/output/src3433143458/src/pages/privacy.vue?macro=true";
import { default as indexY7UeQ5OvGIMeta } from "/codebuild/output/src3433143458/src/pages/recover/index.vue?macro=true";
import { default as successoPrdcveqBmMeta } from "/codebuild/output/src3433143458/src/pages/register/success.vue?macro=true";
import { default as _91id_93NcifQ8QjWtMeta } from "/codebuild/output/src3433143458/src/pages/sales/profile/[id].vue?macro=true";
import { default as indexuzyahvUi4lMeta } from "/codebuild/output/src3433143458/src/pages/sales/profile/index.vue?macro=true";
import { default as statuekTxqdDunCAMeta } from "/codebuild/output/src3433143458/src/pages/statue.vue?macro=true";
import { default as successLmXeUXfoyCMeta } from "/codebuild/output/src3433143458/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubLWsnuyutTBMeta } from "/codebuild/output/src3433143458/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubLWsnuyutTB } from "/codebuild/output/src3433143458/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexS2SLNYqt2GMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutiA6E20Okg3Meta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutiA6E20Okg3Meta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settingsWo8FHPBv6AMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settingsWo8FHPBv6AMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src3433143458/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45account4YDPJztj2GMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45account4YDPJztj2GMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companytSOf0APU6ZMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companytSOf0APU6ZMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consentswV4WJiVVLIMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consentswV4WJiVVLIMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leadsLp8UM5fslJMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leadsLp8UM5fslJMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentsBl7jMkNWTmMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentsBl7jMkNWTmMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premium9Ll4tdS4XQMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premium9Ll4tdS4XQMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profilesib5Lcy2LkJMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profilesib5Lcy2LkJMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: userszIK4Q8MQVYMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: userszIK4Q8MQVYMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passwordI3u9YL83qDMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45passwordI3u9YL83qDMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/change-password.vue")
  },
  {
    name: "chat-id___en",
    path: "/en/chat/:id()",
    meta: _91id_93zBcHPdChM2Meta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/chat/[id].vue")
  },
  {
    name: "chat-id___pl",
    path: "/pl/chat/:id()",
    meta: _91id_93zBcHPdChM2Meta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "/en/chat/ai",
    meta: ai_46clientw5Va0fnZRwMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3433143458/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat-ai___pl",
    path: "/pl/chat/ai",
    meta: ai_46clientw5Va0fnZRwMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3433143458/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat___en",
    path: "/en/chat",
    meta: indexVWuUEJ3LS6Meta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/chat/index.vue")
  },
  {
    name: "chat___pl",
    path: "/pl/chat",
    meta: indexVWuUEJ3LS6Meta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/chat/index.vue")
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93kl30X2saNhMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93kl30X2saNhMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexmo1FxJ8Ui0Meta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexmo1FxJ8Ui0Meta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/client/profile/index.vue")
  },
  {
    name: contacts8zZLO3tXpqMeta?.name,
    path: "/en/contacts",
    meta: contacts8zZLO3tXpqMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_93NjbINmMrnjMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: indexDUnC3wYE4OMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contacts8zZLO3tXpqMeta?.name,
    path: "/pl/contacts",
    meta: contacts8zZLO3tXpqMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_93NjbINmMrnjMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: indexDUnC3wYE4OMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93ZR8Ku1LGf2Meta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93ZR8Ku1LGf2Meta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexS2SLNYqt2GMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexS2SLNYqt2GMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/index.vue")
  },
  {
    name: loginhcAiieRFrpMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src3433143458/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: indexxTA0Va8RDOMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45successbQIy4qIe24Meta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: loginhcAiieRFrpMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src3433143458/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: indexxTA0Va8RDOMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45successbQIy4qIe24Meta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutycdCRF6ruzMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutycdCRF6ruzMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentsEZgYpWODdpMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentsEZgYpWODdpMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrationsfs8jzaaYW9Meta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrationsfs8jzaaYW9Meta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsFWTmqccuUUMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsFWTmqccuUUMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsGToW08zpnfMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsGToW08zpnfMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profile8AyrxadDxxMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profile8AyrxadDxxMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teammAM8fwGJbRMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teammAM8fwGJbRMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/manager/team.vue")
  },
  {
    name: marketplaceA7e77wqEzNMeta?.name,
    path: "/en/marketplace",
    meta: marketplaceA7e77wqEzNMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src3433143458/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clientOCKrpt3vKwMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3433143458/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplaceA7e77wqEzNMeta?.name,
    path: "/pl/marketplace",
    meta: marketplaceA7e77wqEzNMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src3433143458/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clientOCKrpt3vKwMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3433143458/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribeMTP66ZJahHMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribeMTP66ZJahHMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46clientXgcT75xiNcMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3433143458/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46clientXgcT75xiNcMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3433143458/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46clientrUCEEhSCksMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3433143458/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46clientrUCEEhSCksMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3433143458/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacymZVAMGpxyjMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacymZVAMGpxyjMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexY7UeQ5OvGIMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexY7UeQ5OvGIMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src3433143458/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src3433143458/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_93NcifQ8QjWtMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_93NcifQ8QjWtMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: indexuzyahvUi4lMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: indexuzyahvUi4lMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statuekTxqdDunCAMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statuekTxqdDunCAMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successLmXeUXfoyCMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successLmXeUXfoyCMeta || {},
    component: () => import("/codebuild/output/src3433143458/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubLWsnuyutTBMeta?.name,
    path: "/old-page",
    component: component_45stubLWsnuyutTB
  }
]